export default __webpack_public_path__ + "static/media/user.0b3cbcc6.svg";